import { render, staticRenderFns } from "./GetRequests.vue?vue&type=template&id=03e5960e"
import script from "./GetRequests.vue?vue&type=script&lang=js"
export * from "./GetRequests.vue?vue&type=script&lang=js"
import style0 from "./GetRequests.vue?vue&type=style&index=0&id=03e5960e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports